var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-result',{attrs:{"title":"帳戶狀態檢驗","subTitle":"正在檢驗帳戶狀態，請稍等片刻"}},[_c('template',{slot:"icon"},[_c('i',{staticClass:"el-icon-loading",staticStyle:{"font-size":"60px"}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }